import {
  Button,
  Card,
  Form,
  FormItemProps,
  FormProps,
  Icons,
  Input,
  Space,
} from '@pankod/refine-antd'
import { LogicalFilter } from '@pankod/refine-core'
import React from 'react'

export type TFilterForm<T = { keyword: string }> = T

const Filter: React.FC<{
  formProps: FormProps
  showClearAll?: boolean
  filters?: LogicalFilter[]
  className?: string
  layout?: 'vertical' | 'horizontal' | 'inline'
  items?: {
    label: string
    name: string
    placeholder?: string
    component?: React.ReactNode
    className?: string
    required?: boolean
    rules?: FormItemProps['rules']
    dependencies?: FormItemProps['dependencies']
  }[]
  size?: 'small'
}> = ({
  formProps,
  items,
  filters,
  showClearAll,
  layout = 'vertical',
  size,
  className,
}) => {
  const initialValues = filters?.reduce(
    (result, filter) => {
      result[filter.field] = filter.value
      return result
    },
    {} as Record<string, any>,
  )

  return (
    <Card className="!mb-5" size={size}>
      <Form
        layout={layout}
        {...formProps}
        className={className}
        initialValues={initialValues}
        validateTrigger="onBlur"
        size={size}
      >
        {(!items || items.length === 0) && (
          <Form.Item label="Keyword" name="keyword">
            <Input
              placeholder="Search by name, description, content.."
              autoComplete="off"
            />
          </Form.Item>
        )}
        {items &&
          items.length > 0 &&
          items.map(
            ({
              label,
              name,
              placeholder,
              component,
              className,
              required,
              rules,
              dependencies,
            }) => (
              <Form.Item
                key={name}
                label={label}
                name={name}
                className={className}
                required={required}
                rules={rules}
                dependencies={dependencies}
              >
                {!!component ? (
                  component
                ) : (
                  <Input placeholder={placeholder} autoComplete="off" />
                )}
              </Form.Item>
            ),
          )}
        <Form.Item noStyle>
          <Space>
            <Button
              htmlType="submit"
              type="primary"
              icon={<Icons.FilterOutlined />}
              size={size}
            >
              Filter
            </Button>
            {showClearAll && (
              <Button
                onClick={() => {
                  formProps.form?.resetFields()
                  formProps.form?.submit()
                }}
                size={size}
              >
                Clear
              </Button>
            )}
          </Space>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default Filter
